module.exports = __webpack_public_path__ + "img/CNA_logo.ca5a9b99.png";